import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 400,
  parentId: 0,
  name: "Dashboard",
  label: "Dashboard",
  path: "dashboard",
  element: Element,
  user: true,
  nonVerified: true,
  admin: false,
  hidden: false,
};

export default route;
